import { Model as r } from "../../model.js";
class c extends r {
  constructor(o, t, s, i, a) {
    super(), this.areas = o ?? [], this.locations = t ?? [], this.locationGroups = s ?? [], this.organizations = i ?? [], this.additionalData = a;
  }
}
export {
  c as ScopeModel
};
//# sourceMappingURL=scope.model.js.map
